import api from "@/utils/api";

export const downloadBlob = async (url, filename) => {
  const r = await api.get(url, { responseType: "blob" });
  const href = window.URL.createObjectURL(new Blob([r.data]));
  const a = document.createElement("a");
  a.href = href;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(href);
};

export const downloadCertificate = (attempt) =>
  downloadBlob(`/api/quiz/attempts/${attempt.attempt_id}/certificate`,
    `tots360_Certificate_${(attempt.full_name || "Parent").replace(/\s+/g, "_")}.pdf`);

export const downloadCertificateImage = (attempt) =>
  downloadBlob(`/api/quiz/attempts/${attempt.attempt_id}/certificate?format=png&hd=true`,
    `tots360_Certificate_${(attempt.full_name || "Parent").replace(/\s+/g, "_")}.png`);

export const fetchCertificateImage = async (attempt) => {
  const r = await api.get(`/api/quiz/attempts/${attempt.attempt_id}/certificate?format=png`, { responseType: "blob" });
  return window.URL.createObjectURL(r.data);
};

export const RESULT_COPY = {
  high_performer: { label: "High Performer", color: "#FFE66D" },
  good: { label: "Good", color: "#4ECDC4" },
};
